// Иконите на схемата — SVG-тата от дизайна (линейни, 24×24, `currentColor`).
// antd няма бар/растение/DJ/сцена, а за останалите дизайнът е с по-тънък
// щрих от outlined иконите, затова всички са тук.

type IconProps = { className?: string; strokeWidth?: number };

const IconFrame = ({
  className,
  strokeWidth = 2,
  children,
}: IconProps & { children: React.ReactNode }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    {children}
  </svg>
);

// ── Видове елементи ─────────────────────────────────────────────────────────

export const TableIcon = (props: IconProps) => (
  <IconFrame {...props}>
    <circle cx="12" cy="12" r="6" />
    <path d="M12 2v2M12 20v2M2 12h2M20 12h2" />
  </IconFrame>
);

/** Маса, погледната отстрани (кръгъл плот на крак) — до номерата на масите в текст. */
export const DiningTableIcon = (props: IconProps) => (
  <IconFrame {...props}>
    <ellipse cx="12" cy="9" rx="7" ry="2.5" />
    <path d="M12 11.5V19M9 19h6" />
  </IconFrame>
);

export const BarIcon = (props: IconProps) => (
  <IconFrame {...props}>
    <path d="M8 22h8M12 15v7M7 3h10l-1 7a4 4 0 0 1-8 0z" />
  </IconFrame>
);

export const WallIcon = (props: IconProps) => (
  <IconFrame {...props}>
    <rect x="3" y="4" width="18" height="16" rx="1" />
    <path d="M3 10h18M3 16h18M9 4v6M15 10v6M9 16v4" />
  </IconFrame>
);

export const PlantIcon = (props: IconProps) => (
  <IconFrame {...props}>
    <path d="M12 20v-8M12 12c0-4-3-6-7-6 0 4 3 6 7 6zM12 12c0-4 3-6 7-6 0 4-3 6-7 6z" />
  </IconFrame>
);

export const EntranceIcon = (props: IconProps) => (
  <IconFrame {...props}>
    <path d="M6 21V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v17M3 21h18M14 12h.01" />
  </IconFrame>
);

export const StageIcon = (props: IconProps) => (
  <IconFrame {...props}>
    <rect x="9" y="2" width="6" height="12" rx="3" />
    <path d="M5 11a7 7 0 0 0 14 0M12 18v4" />
  </IconFrame>
);

export const DjIcon = (props: IconProps) => (
  <IconFrame {...props}>
    <circle cx="12" cy="12" r="9" />
    <circle cx="12" cy="12" r="3" />
  </IconFrame>
);

// ── Интерфейс ───────────────────────────────────────────────────────────────

export const PersonIcon = (props: IconProps) => (
  <IconFrame strokeWidth={2.6} {...props}>
    <circle cx="12" cy="8" r="4" />
    <path d="M4 21a8 8 0 0 1 16 0" />
  </IconFrame>
);

export const UndoIcon = (props: IconProps) => (
  <IconFrame {...props}>
    <path d="M9 14 4 9l5-5" />
    <path d="M4 9h11a5 5 0 0 1 0 10h-3" />
  </IconFrame>
);

export const RedoIcon = (props: IconProps) => (
  <IconFrame {...props}>
    <path d="m15 14 5-5-5-5" />
    <path d="M20 9H9a5 5 0 0 0 0 10h3" />
  </IconFrame>
);

export const CheckIcon = (props: IconProps) => (
  <IconFrame strokeWidth={2.4} {...props}>
    <path d="M20 6 9 17l-5-5" />
  </IconFrame>
);

export const ClockIcon = (props: IconProps) => (
  <IconFrame strokeWidth={2.4} {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </IconFrame>
);

export const SlidersIcon = (props: IconProps) => (
  <IconFrame {...props}>
    <path d="M4 21v-7M4 10V3M12 21v-9M12 8V3M20 21v-5M20 12V3M1 14h6M9 8h6M17 16h6" />
  </IconFrame>
);

export const PlusIcon = (props: IconProps) => (
  <IconFrame strokeWidth={2.2} {...props}>
    <path d="M12 5v14M5 12h14" />
  </IconFrame>
);

export const MinusIcon = (props: IconProps) => (
  <IconFrame strokeWidth={2.2} {...props}>
    <path d="M5 12h14" />
  </IconFrame>
);

export const FitIcon = (props: IconProps) => (
  <IconFrame {...props}>
    <path d="M8 3H5a2 2 0 0 0-2 2v3M21 8V5a2 2 0 0 0-2-2h-3M3 16v3a2 2 0 0 0 2 2h3M16 21h3a2 2 0 0 0 2-2v-3" />
  </IconFrame>
);

export const RotateRightIcon = (props: IconProps) => (
  <IconFrame {...props}>
    <path d="M21 12a9 9 0 1 1-3-6.7L21 8" />
    <path d="M21 3v5h-5" />
  </IconFrame>
);

export const RotateLeftIcon = (props: IconProps) => (
  <IconFrame {...props}>
    <path d="M3 12a9 9 0 1 0 3-6.7L3 8" />
    <path d="M3 3v5h5" />
  </IconFrame>
);

export const DuplicateIcon = (props: IconProps) => (
  <IconFrame {...props}>
    <rect x="8" y="8" width="13" height="13" rx="2" />
    <path d="M4 16V5a2 2 0 0 1 2-2h10" />
  </IconFrame>
);

export const TrashIcon = (props: IconProps) => (
  <IconFrame {...props}>
    <path d="M3 6h18M8 6V4h8v2M6 6l1 15h10l1-15" />
  </IconFrame>
);

export const CloseIcon = (props: IconProps) => (
  <IconFrame strokeWidth={2.2} {...props}>
    <path d="M18 6 6 18M6 6l12 12" />
  </IconFrame>
);

export const InfoIcon = (props: IconProps) => (
  <IconFrame {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 11v5M12 8h.01" />
  </IconFrame>
);
